import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "@fontsource/inter";
import "./App.css";
import axios from "axios";
import FilterByAssistant from "./Components/FilterByAssistant";
import LoadingOverlay from "./Components/spinner";

const CallDashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: "started_at",
    direction: "descending",
  });
  const [modalContent, setModalContent] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [clientLocation, setClientLocation] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [isSummary, setIsSummary] = useState(false); // Track if it's a summary or transcript
  const [token, setToken] = useState(null); //added to make the token accessible to other
  // Fetching client data from URL params
  useEffect(() => {
    const fetchClientData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const ghlDashboardToken = urlParams.get("token"); // Get token from the URL
      setToken(ghlDashboardToken);
      // Fetch client data using the token
      const { data: clientData, error: clientError } = await supabase
        .from("Clients")
        .select("id, ghl_location_id, location")
        .eq("ghl_dashboard_token", ghlDashboardToken) // Correctly applying the filter
        .single();
      if (clientError) {
        console.error("Error fetching client data:", clientError);
      } else {
        const clientId = clientData.id;
        const clientLocation = clientData.location;
        setClientId(clientId); // Store clientId for use in subsequent calls
        setClientLocation(clientLocation);
      }
    };

    fetchClientData();
  }, []); // Empty dependency array to run on mount only

  const handleQuickDateSelect = (range) => {
    const timeZone = "Australia/Sydney";
    const now = new Date();
    let startDate, endDate;

    // Sydney timezone offset (Adjust for DST if needed)
    const sydneyOffset = now.getTimezoneOffset() / -60; // Will be 11 or 10

    if (range === "today") {
      const options = {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const formatter = new Intl.DateTimeFormat("en-CA", options); // Using en-CA to ensure YYYY-MM-DD format

      const [{ value: year }, , { value: month }, , { value: day }] =
        formatter.formatToParts(now);

      // Create start and end dates in Sydney timezone
      const start = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
      const end = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
      console.log(start, end);
      startDate = new Date(start).toISOString().split("T")[0];
      endDate = new Date(end).toISOString().split("T")[0];
    } else if (range === "thisWeek") {
      // Get current day in Sydney time
      const sydneyNow = new Date(now.getTime() + sydneyOffset * 60 * 60 * 1000);
      const dayOfWeek = sydneyNow.getDay(); // 0 = Sunday, 1 = Monday, etc.

      // Get start of the week (Monday in Sydney time)
      const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
      const sydneyStartOfWeek = new Date(sydneyNow);
      sydneyStartOfWeek.setDate(sydneyNow.getDate() + diffToMonday);
      sydneyStartOfWeek.setHours(0, 0, 0, 0);

      // Convert to UTC
      const startOfWeekUTC = new Date(
        sydneyStartOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
      );
      startDate = startOfWeekUTC.toISOString().split("T")[0];

      // End of the week (Sunday 23:59 Sydney time)
      const sydneyEndOfWeek = new Date(sydneyStartOfWeek);
      sydneyEndOfWeek.setDate(sydneyStartOfWeek.getDate() + 6);
      sydneyEndOfWeek.setHours(23, 59, 59, 999);

      const endOfWeekUTC = new Date(
        sydneyEndOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
      );
      endDate = endOfWeekUTC.toISOString().split("T")[0];
    } else if (range === "thisMonth") {
      const options = { timeZone, year: "numeric", month: "2-digit" };
      const formatter = new Intl.DateTimeFormat("en-CA", options); // Using en-CA to ensure YYYY-MM-DD format

      const [{ value: year }, , { value: month }] =
        formatter.formatToParts(now);

      // Create start and end dates for the current month
      const start = new Date(`${year}-${month}-01T00:00:00.000Z`);
      const end = new Date(start);
      end.setMonth(end.getMonth() + 1);
      end.setDate(0); // Set to last day of previous month (i.e., last day of current month)
      end.setHours(23, 59, 59, 999);
      startDate = new Date(start).toISOString().split("T")[0];
      endDate = new Date(end).toISOString().split("T")[0];
    }

    // // Sydney timezone offset (Adjust for DST if needed)
    // const sydneyOffset = now.getTimezoneOffset() / -60; // Will be 11 or 10

    // if (range === "today") {
    //   // Convert Sydney midnight to UTC
    //   const sydneyMidnight = new Date(now);
    //   sydneyMidnight.setHours(0, 0, 0, 0); // Set to start of the day in Sydney

    //   // Convert Sydney start to UTC
    //   const startOfDayUTC = new Date(
    //     sydneyMidnight.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );

    //   startDate = startOfDayUTC.toISOString().split("T")[0];

    //   // End of today is just before Sydney's midnight (23:59:59)
    //   const endOfDayUTC = new Date(
    //     sydneyMidnight.getTime() + (24 - sydneyOffset) * 60 * 60 * 1000 - 1
    //   );
    //   endDate = endOfDayUTC.toISOString().split("T")[0];
    // } else if (range === "thisWeek") {
    //   // Get current day in Sydney time
    //   const sydneyNow = new Date(now.getTime() + sydneyOffset * 60 * 60 * 1000);
    //   const dayOfWeek = sydneyNow.getDay(); // 0 = Sunday, 1 = Monday, etc.

    //   // Get start of the week (Monday in Sydney time)
    //   const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
    //   const sydneyStartOfWeek = new Date(sydneyNow);
    //   sydneyStartOfWeek.setDate(sydneyNow.getDate() + diffToMonday);
    //   sydneyStartOfWeek.setHours(0, 0, 0, 0);

    //   // Convert to UTC
    //   const startOfWeekUTC = new Date(
    //     sydneyStartOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );
    //   startDate = startOfWeekUTC.toISOString().split("T")[0];

    //   // End of the week (Sunday 23:59 Sydney time)
    //   const sydneyEndOfWeek = new Date(sydneyStartOfWeek);
    //   sydneyEndOfWeek.setDate(sydneyStartOfWeek.getDate() + 6);
    //   sydneyEndOfWeek.setHours(23, 59, 59, 999);

    //   const endOfWeekUTC = new Date(
    //     sydneyEndOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );
    //   endDate = endOfWeekUTC.toISOString().split("T")[0];
    // }

    setStartDate(startDate);
    setEndDate(endDate);
  };

  // Clear quick select buttons
  const clearFilters = () => {
    setSearchTerm("");
    setStartDate("");
    setEndDate("");
  };

  // State for search term and date range
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Fetching calls data
  useEffect(() => {
    const fetchData = async () => {
      if (!clientId) return; // Don't fetch calls until clientId is available

      const { data: calls, error } = await supabase
        .from("Calls")
        .select("*")
        .eq("supabase_client_id", clientId) // Ensure you're filtering calls for the specific client
        .order("started_at", { ascending: false }); // Sort calls by started_at descending
      if (error) {
        console.error("Error fetching calls:", error);
      } else {
        // Fetch client data (ghl_location_id) for each call
        const enrichedCalls = await Promise.all(
          //refactored this code for a more faster load time
          calls.map(async (call) => {
            let duration = 0;
            console.log(call);
            let costs = (call?.costs || [])[0] || [];
            for (let i = 0; i < costs.length; i++) {
              const cost = costs[i];
              call[cost.type + "_cost_breakdown"] = cost;
            }
            return {
              ...call,
              duration,
              ghl_location_id: token || null,
            };
          })
        );

        setData(enrichedCalls); // Set the enriched data to state
      }

      setLoading(false); // Stop loading after data is fetched
    };

    fetchData();
  }, [clientId]); // Only run fetchData when clientId is set

  // Parse the conversation
  const parseConversation = (transcription) => {
    const messages = [];

    // Split by "User:" or "AI:"
    const splitMessages = transcription.split(/(?=User:|AI:)/);

    // Process each message
    splitMessages.forEach((message) => {
      if (message.startsWith("User:")) {
        messages.push({
          sender: "User",
          text: message.replace("User:", "").trim(),
        });
      } else if (message.startsWith("AI:")) {
        messages.push({
          sender: "AI",
          text: message.replace("AI:", "").trim(),
        });
      }
    });

    return messages;
  };

  // Sorting function with arrows
  const handleSort = (key, type) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "ascending"
        ? "descending"
        : "ascending";
    setSortConfig({ key, direction });

    const sortedData = [...data].sort((a, b) => {
      const valA = a[key] || (type === "string" ? "" : 0);
      const valB = b[key] || (type === "string" ? "" : 0);

      if (type === "date") {
        return direction === "ascending"
          ? new Date(valA) - new Date(valB)
          : new Date(valB) - new Date(valA);
      }
      if (type === "string") {
        return direction === "ascending"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      return direction === "ascending" ? valA - valB : valB - valA;
    });

    setData(sortedData);
  };

  // Handle search input
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  // --new--
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedFilter, startDate, endDate]);
  // --end--
  // Filtered data based on search and date range
  const filteredData = data.filter((call) => {
    const customerName = call.customer_name
      ? call.customer_name.toLowerCase()
      : "";
    const customerPhone = call.customer_number
      ? call.customer_number.toLowerCase()
      : "";

    const matchesSearchTerm =
      customerName.includes(searchTerm.toLowerCase()) ||
      customerPhone.includes(searchTerm.toLowerCase());
    // console.log(
    //   new Date(call.started_at).toLocaleString("en-AU", {
    //     timeZone: "Australia/Sydney",
    //   }),
    //   new Date(startDate).setHours(0, 0, 0, 0),
    //   new Date(endDate).setHours(23, 59, 59, 999)
    // );
    const matchesDateRange =
      (!startDate ||
        new Date(call.started_at) >=
          new Date(startDate).setHours(0, 0, 0, 0)) &&
      (!endDate ||
        new Date(call.started_at) <=
          new Date(endDate).setHours(23, 59, 59, 999));

    const matchesAssistant =
      selectedFilter === "All" ||
      (selectedFilter === "Rec" && call.assistant === "Receptionist") ||
      (selectedFilter === "Inst" && call.assistant === "Instant Follow Up");

    return matchesSearchTerm && matchesDateRange && matchesAssistant;
  });

  // Function to open modal with content based on type (transcript or summary)
  const openModal = (content, customerName, isSummary = false) => {
    // Only open modal if content is not empty
    if (content && content.trim()) {
      setCustomerName(customerName); // Store the customer name
      setIsModalOpen(true); // Open modal
      setIsSummary(isSummary); // Set whether the content is a summary or not
      setModalContent(content.replace(/\\n/g, "\n")); // Handle content formatting
    }
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
    setCustomerName(""); // Clear the customer name when closing the modal
  };

  // Handle page change
  const handlePageChange = (direction) => {
    if (direction === "next") {
      setCurrentPage((prevPage) => prevPage + 1);
    } else if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Calculate the current page data
  const currentPageData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const [updatingFollowUp, setUpdatingFollowUp] = useState(false);
  const followUpCall = async (call_id = "", checked = false) => {
    console.log(call_id, checked);
    if (!call_id) return;
    setUpdatingFollowUp(true);
    // https://automations.creativedigital.ai/webhook-test/followup
    const headers = {
      "Content-Type": "application/json",
    };
    const response = await axios.post(
      "https://automations.creativedigital.ai/webhook/followup",
      {
        call_id,
        followed_up: checked,
      },
      {
        headers: headers,
      }
    );
    if (response.status == 200) {
      let list = [...data];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (call_id == item.id) {
          item.followed_up = checked;
          break;
        }
      }
      setUpdatingFollowUp(false);
    } else {
      setUpdatingFollowUp(false);
    }
  };
  return (
    <div className="App">
      <h1>Calls Dashboard {clientLocation && `- ${clientLocation}`}</h1>

      {/* Parent container for both Quick Select and Filters */}
      <div className="top-container">
        {/* Quick Date Select Links */}
        <div className="quick-date-select">
          <span onClick={() => handleQuickDateSelect("today")}>Today</span>
          <span onClick={() => handleQuickDateSelect("thisWeek")}>
            This Week
          </span>
          <span onClick={() => handleQuickDateSelect("thisMonth")}>
            This Month
          </span>

          {/* Clear Filters Button */}
          <span onClick={clearFilters}>All</span>
        </div>

        {/* Search and Date Range Filters */}
        <div className="filters">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name or phone number"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <FilterByAssistant
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />
          <div className="date-range">
            <input
              type="date"
              className="date-range-input"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              type="date"
              className="date-range-input"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>
      <LoadingOverlay isLoading={updatingFollowUp} />
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-container">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th onClick={() => handleSort("started_at", "date")}>
                    Started At{" "}
                    {sortConfig.key === "started_at" &&
                      (sortConfig.direction === "descending" ? "↓" : "↑")}
                  </th>
                  <th onClick={() => handleSort("ended_at", "date")}>
                    Ended At{" "}
                    {sortConfig.key === "ended_at" &&
                      (sortConfig.direction === "descending" ? "↓" : "↑")}
                  </th>
                  <th onClick={() => handleSort("customer_name", "string")}>
                    Customer Name{" "}
                    {sortConfig.key === "customer_name" &&
                      (sortConfig.direction === "descending" ? "↓za" : "↑az")}
                  </th>
                  <th>Customer Number</th>
                  <th>Assistant</th>
                  <th>Summary</th>
                  <th>Transcript</th>
                  <th>Recording</th>
                  <th style={{ textAlign: "center" }}>Followed Up</th>
                </tr>
              </thead>
              <tbody>
                {currentPageData.map((call) => (
                  <tr key={call.id}>
                    {/* <td>{call?.vapi_cost_breakdown?.cost || ""}</td> */}
                    {/* <td>{(call.duration_seconds / 60).toFixed(2)}</td> */}
                    <td className="start-date-column">
                      {new Date(call.started_at).toLocaleString("en-AU", {
                        timeZone: "Australia/Sydney",
                      })}
                    </td>
                    <td>
                      {new Date(call.ended_at).toLocaleString("en-AU", {
                        timeZone: "Australia/Sydney",
                      })}
                    </td>
                    <td>
                      {/* Dynamically create the URL using ghl_location_id and ghl_id */}
                      {call.ghl_location_id && call.ghl_id ? (
                        <a
                          href={`https://app.gohighlevel.com/v2/location/${call.ghl_location_id}/contacts/detail/${call.ghl_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {call.customer_name}
                        </a>
                      ) : (
                        call.customer_name
                      )}
                    </td>
                    <td>{call.customer_number}</td>
                    <td>{call.assistant}</td>

                    {/* Only show "See All" button if summary is not empty */}

                    <td className="summary-column">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: call.summary.replace(/\n/g, "<br>"),
                        }}
                      />{" "}
                      <br></br>
                      <button
                        onClick={() =>
                          openModal(
                            call.summary.replace(/\n/g, "<br>"),
                            call.customer_name,
                            true
                          )
                        }
                      >
                        See All
                      </button>
                    </td>

                    {/* Only show "View Transcript" button if transcript is not empty */}
                    <td className="transcript-column">
                      {call.transcript && call.transcript.trim() ? (
                        <button
                          onClick={() =>
                            openModal(
                              call.transcript,
                              call.customer_name,
                              false
                            )
                          }
                        >
                          View
                        </button>
                      ) : null}
                    </td>
                    <td className="recording-column">
                      <button
                        onClick={() => {
                          window.open(
                            call.recording_url,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        Listen
                      </button>
                    </td>
                    <td className="followed-up-column">
                      <input
                        type="checkbox"
                        checked={call.followed_up}
                        onChange={(e) => {
                          followUpCall(call.id, e.target.checked);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // Prevent background click from closing modal
          >
            <div className="modal-header">
              <span className="close-button" onClick={closeModal}>
                &times;
              </span>
              {/* Dynamically set the title based on isSummary */}
              <h2>
                {isSummary ? "Summary" : "Transcript"} - {customerName}
              </h2>
            </div>
            {/* Modal Body with Chat */}
            <div className="modal-body">
              <div className="chat-container">
                {/* Render either summary or transcript */}
                {isSummary ? (
                  <div className="summary-content">
                    <div
                      className="summary-text"
                      dangerouslySetInnerHTML={{
                        __html: modalContent, // Ensure modalContent is HTML formatted
                      }}
                    />
                  </div>
                ) : (
                  parseConversation(modalContent).map((message, index) => (
                    <div
                      key={index}
                      className={`chat-message ${
                        message.sender === "User"
                          ? "user-message"
                          : "ai-message"
                      }`}
                    >
                      <div className="message-text">{message.text}</div>
                      <div
                        className={`message-label ${
                          message.sender === "User" ? "user-label" : "ai-label"
                        }`}
                      >
                        {message.sender}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Results per page dropdown */}

      <div className="top-container">
        <div className="results-per-page">
          <label htmlFor="itemsPerPage">Results per page: </label>
          <select
            id="itemsPerPage"
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>

        {/* Calls Counter */}
        <div className="calls-counter">
          <p>{filteredData.length} Calls Found</p>
        </div>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          {currentPage === 1
            ? `Page ${currentPage}`
            : `Page ${currentPage} of ${Math.ceil(
                filteredData.length / itemsPerPage
              )}`}
        </span>
        <button
          onClick={() => handlePageChange("next")}
          disabled={
            currentPage >= Math.ceil(filteredData.length / itemsPerPage)
          }
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CallDashboard;
